// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-AutoDocExtraction-QuotesSection-Quote-module__quote";
var _2 = "webpack-concepts-AutoDocExtraction-QuotesSection-Quote-module__quoteButton";
var _3 = "webpack-concepts-AutoDocExtraction-QuotesSection-Quote-module__quoteContainer";
var _4 = "webpack-concepts-AutoDocExtraction-QuotesSection-Quote-module__viewInPdfButton";
export { _1 as "quote", _2 as "quoteButton", _3 as "quoteContainer", _4 as "viewInPdfButton" }
